export default __webpack_public_path__ + "static/Alegreya-Bold-ced7de5a0a28b5c453c1dada96924d4e.ttf";